import { jsx as _jsx } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import StopCircleIcon from "@mui/icons-material/StopCircle";
import { RoundActionIconButton } from "../../components/Buttons/ActionIconButton/RoundActionIconButton";
import { useTheme } from "@mui/material";
const StopButton = ({ handleStop, waiting, }) => {
    const theme = useTheme();
    return (_jsx(RoundActionIconButton, Object.assign({ size: "small", onClick: handleStop, baseColor: theme.palette.info.light, disabled: waiting }, { children: _jsx(StopCircleIcon, { fontSize: "medium" }) })));
};
export default StopButton;
